// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"8":"f9682ed4","381":"891719fd","561":"40544706","713":"fcb8f8e2","728":"f4a6eab0","897":"42e99671"}[chunkId] + ".chunk.css";
};